import { CreateSupportResponse } from '@/app/services/supportService/createSupport'
import { SupportCategoryEnum } from '@/app/utils/supportCategoryEnum'

export interface MergedSupportData {
  _id: string
  contract?: string
  name: string[]
  cpf: string[]
  phone: string[]
  type: string
}

export const prepareSupportData = (data: CreateSupportResponse | undefined) => {
  if (!data) return
  return [
    ...data.sellers.map((seller) => ({
      _id: seller._id,
      contract: '-',
      name: [seller.name],
      cpf: [seller.cpf],
      phone: [seller.phone],
      type: SupportCategoryEnum.USER,
    })),
    ...data.customers.map((customer) => ({
      _id: customer._id,
      contract: '-',
      name: [customer.name],
      cpf: [customer.cpf],
      phone: [customer.phone],
      type: SupportCategoryEnum.CUSTOMER,
    })),
    ...data.transactions.map((transaction) => ({
      _id: transaction._id,
      contract: transaction.contract,
      name: [transaction.sellerName, transaction.customerName],
      cpf: [transaction.sellerCpf, transaction.customerCpf],
      phone: [transaction.sellerPhone, transaction.customerPhone],
      type: SupportCategoryEnum.TRANSACTION,
    })),
  ]
}
